import ContentContainer from "@/components/ContentContainer/ContentContainer";
import React from "react";
import styles from "./ProductCardsLoader.module.css";

interface ProductCardsLoaderProps {
  className?: string;
}

const ProductCardsLoader: React.FC<ProductCardsLoaderProps> = ({
  className = "",
}) => {
  return (
    <ContentContainer
      spacing="product-cards"
      className={`bg-neutral-light w-full px-6 mx-auto md:px-8 lg:px-16 pt-10 md:pt-12 lg:pt-16 xl:pt-20 max-w-none md:max-w-[var(--container-tablet)]
  lg:max-w-[var(--container-desktop)] ${className}`}
    >
      <div className="mb-16 text-left">
        <h2 className="mb-4 text-display2 text-neutral-900 font-x-sans">
          High-power internet, at the speed you need
        </h2>
        <p className="text-body2">
          Fast, reliable, and all-around excellent. Choose the right plan for
          you.
        </p>
      </div>

      <div
        className="flex justify-center items-center"
        style={{ minHeight: "400px" }}
      >
        <div className="flex flex-col items-center">
          <div className={styles.dotWrapper}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
          </div>
        </div>
      </div>
    </ContentContainer>
  );
};

export default ProductCardsLoader;
